import classNames from 'classnames';
import styles from './AcademyFilters.module.scss';
import { FormfieldSelect, GridCell, Grid } from 'ui/components';

export interface AcademyFiltersProps {
	className?: string;
	dictionary?: { [key: string]: string };
	filterOptions?: Models.AcademyFilters;
	selectedAcademyType?: string;
	handleTypeChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
	selectedAcademyLanguage?: string;
	handleLanguageChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

export const AcademyFilters: React.FC<AcademyFiltersProps> = ({
	className,
	dictionary,
	filterOptions,
	handleTypeChange,
	selectedAcademyType,
	handleLanguageChange,
	selectedAcademyLanguage,
}) => {
	const transformTypeOptions = () => {
		if (!filterOptions?.types) return [];

		return Object.entries(filterOptions.types).map(([label, id], index) => ({
			label: label,
			value: id,
			text: label,
			hidden: false,
			disabled: false,
		}));
	};
	const transformLanguageOptions = () => {
		if (!filterOptions?.languages) return [];

		return Object.entries(filterOptions.languages).map(([label, id], index) => ({
			label: label,
			value: id,
			text: label,
			hidden: false,
			disabled: false,
		}));
	};

	return (
		<Grid wrap={true} className={classNames(styles.AcademyFilter, className)}>
			{filterOptions?.types && (
				<GridCell desktopWidth="33" mobileWidth="100">
					<FormfieldSelect
						id="academyTypes"
						name="academyTypes"
						labelStyle="normalWeb"
						className={styles.AcademyFilter_selectField}
						variant="website"
						layout="row"
						label={dictionary?.academyFilterTypesLabel}
						handleChange={handleTypeChange}
						options={transformTypeOptions()}
						defaultValue={selectedAcademyType}
					/>
				</GridCell>
			)}
			{filterOptions?.languages && (
				<GridCell desktopWidth="33" mobileWidth="100">
					<FormfieldSelect
						id="academyLanguages"
						name="academyLanguages"
						className={styles.AcademyFilter_selectField}
						variant="website"
						layout="row"
						labelStyle="normalWeb"
						label={dictionary?.academyFilterLanguagesLabel}
						handleChange={handleLanguageChange}
						options={transformLanguageOptions()}
						defaultValue={selectedAcademyLanguage}
					/>
				</GridCell>
			)}
		</Grid>
	);
};
